import { Link } from "react-router-dom";
import { updateComplexAreaPriceV4 } from "../../../repository/RealEstateRepository";

const ComplexAreaList = (props) => {
    return (<>
        <table className="table table-sm">
            <thead>
                <tr>
                    <th>앞마당</th>
                    <th>생활권</th>
                    <th>단지</th>
                    <th>면적</th>
                    <th>매매가</th>
                    <th>전세가</th>
                    <th>전세가율</th>
                    <th>매전갭</th>
                    <th>최고가</th>
                    <th>전고대비</th>
                    <th style={{ color: "#aaa" }}>전고갭</th>
                    <th style={{ color: "#aaa" }}>수익률</th>
                </tr>
            </thead>
            <tbody>
                {props.content.map(v => (<ComplexAreaListItem key={v.complex.id + "-" + v.generalSupplyArea + "-" + v.generalExclusiveArea} item={v} refresh={props.refresh} />))}
                {!props.content.length && <><tr><td colSpan={12}>NOT FOUND.</td></tr></>}
            </tbody>
        </table>
    </>);
};

const ComplexAreaListItem = (props) => {
    const { item } = props;
    item.lastDealLeaseGap = item.lastDealPrice > 0 && item.lastLeasePrice > 0 ? item.lastDealPrice - item.lastLeasePrice : 0;

    const onChangeDealPrice = (e) => {
        const complexAreaId = e.target.dataset.id;
        const dealPrice = e.target.value;
        (dealPrice > 0) && updateComplexAreaPriceV4({ complexAreaId, dealPrice }, () => {
            props.refresh && props.refresh();
            window.Toast.info("UPDATED!");
        });
    };

    const onChangeLeasePrice = (e) => {
        const complexAreaId = e.target.dataset.id;
        const leasePrice = e.target.value;
        (leasePrice > 0) && updateComplexAreaPriceV4({ complexAreaId, leasePrice }, () => {
            props.refresh && props.refresh();
            window.Toast.info("UPDATED!");
        });
    };

    const onChangeTopDealPrice = (e) => {
        const complexAreaId = e.target.dataset.id;
        const topDealPrice = e.target.value;
        (topDealPrice > 0) && updateComplexAreaPriceV4({ complexAreaId, topDealPrice }, () => {
            props.refresh && props.refresh();
            window.Toast.info("UPDATED!");
        });
    };

    const inputStyle = {
        maxWidth: 70,
        border: "none",
        borderBottom: "1px solid #000",
        textAlign: "center"
    };

    const assistanceStyle = {
        fontSize: "0.9em",
        color: "#555"
    };

    const leaseRatioOfDealText = item.leaseRatioOfDeal === 0 ? "-" : `${(item.leaseRatioOfDeal * 100).toFixed(1)}%`;
    const lastLeaseRatioOfDealText = "-";
    const dealRatioOfTopDealText = item.dealRatioOfTopDeal === 0 ? "-" : `${(item.dealRatioOfTopDeal * 100).toFixed(1)}%`;

    return (
        <tr>
            <td>{item.complex.frontYardName}</td>
            <td>{item.complex.livingAreaName}</td>
            <td><Link to={`/realestate/complex/${item.complex.id}`}>{item.complex.name} {item.complex.approvedYear}({item.complex.age}년차)/{item.complex.totalHouseholdCount}세대</Link></td>
            <td>{item.generalSupplyArea}/{item.generalExclusiveArea}</td>
            <td>
                <input type="text" style={inputStyle} data-id={item.complexAreaId} defaultValue={item.dealPrice} onBlur={onChangeDealPrice} />
                <br />
                <div style={assistanceStyle}>({item.lastDealPrice})</div>
            </td>
            <td>
                <input type="text" style={inputStyle} data-id={item.complexAreaId} defaultValue={item.leasePrice} onBlur={onChangeLeasePrice} />
                <br />
                <div style={assistanceStyle}>({item.lastLeasePrice})</div>
            </td>
            <td>
                {leaseRatioOfDealText}
                <br />
                <div style={assistanceStyle}>({lastLeaseRatioOfDealText})</div>
            </td>
            <td>
                <b>{item.dealLeaseGap === 0 ? "-" : item.dealLeaseGap}</b>
                <br />
                <div style={assistanceStyle}>({item.lastDealLeaseGap === 0 ? "-" : item.lastDealLeaseGap})</div>
            </td>
            <td><input type="text" style={inputStyle} data-id={item.complexAreaId} defaultValue={item.topDealPrice} onBlur={onChangeTopDealPrice} /></td>
            <td>{dealRatioOfTopDealText}</td>
            <td>{item.topDealPrice > 0 && item.dealPrice > 0 ? item.topDealPrice - item.dealPrice : `-`}</td>
            <td>{item.topDealPrice > 0 && item.dealPrice > 0 && item.dealLeaseGap > 0 ? ((item.topDealPrice - item.dealPrice) / item.dealLeaseGap * 100).toFixed(1) + "%" : `-`}</td>
        </tr>
    );
}

export { ComplexAreaList };
